import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subject, from } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { TlPagination } from 'src/app/interfaces/general-interfaces';
import { ListsHttpService } from 'src/app/services/http-services/lists/lists-http.service';
import {UserRoles} from '../../../enums/general-enums';

@Component({
  selector: 'app-recommended-listers',
  templateUrl: './recommended-listers.component.html',
})
export class RecommendedListersComponent implements OnInit {
  recommendedListers: any[] = [];
  pagination!: TlPagination;
  pageNum = 1;
  loading = false;
  private searchSubject = new Subject<string>();
  searchTerm = '';
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  @ViewChild('recommendedListersContainter', { static: false }) private recommendedListersContainter!: ElementRef;

  constructor(
    private listsHttpService: ListsHttpService
  ) { }

  ngOnInit(): void {
    this.getRecommendedListersV2();
    this.searchSubject.pipe(
      debounceTime(300),
      switchMap((searchTerm: string) => from(this.getRecommendedListersV2(searchTerm)))
    ).subscribe(response => {
      this.recommendedListers = response.data;
      this.pagination = response.pagination;
    });
  }

  getRecommendedListersV2(searchTerm?: string) {
    this.loading = true;
    return (
      this.listsHttpService.getRecommendedListersV2(this.pageNum, searchTerm).then((response: any) => {
        this.recommendedListers = [...this.recommendedListers, ...response.data];
        this.pagination = response.pagination;
        this.loading = false;
        return response;
      })
    );
  }

  onScroll(): void {
    const container = this.recommendedListersContainter.nativeElement;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

    if (!this.loading && isAtBottom && ((this.pagination?.currentPage ?? 0) < (this.pagination?.lastPage ?? 0))) {
      this.pageNum++;
      this.getRecommendedListersV2();
    }
  }

  onSearchChange(event: any): void {
    this.searchTerm = event.target.value;
    this.pageNum = 1;
    this.searchSubject.next(this.searchTerm);
  }

  resetSearch() {
    this.searchTerm = '';
    this.searchSubject.next('');
  }

  protected readonly UserRoles = UserRoles;
}
